import { Location } from "@angular/common";
import { HttpParams } from "@angular/common/http";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { forkJoin, Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { environment } from "../../../environments/environment";
import { CONFIG } from "../../core/config/config";
import { DoctorCommentModel } from "../../models/doctor-comment.model";
import { DoctorCriteriaRatingModel } from "../../models/doctor-criteria-rating.model";
import { DoctorPublicProfileModel } from "../../models/doctor-public-profile.model";
import { LanguageService } from "../../services";
import { DoctorService } from "../../services/doctor.service";
import { CovidWarningComponent } from "../../shared/dialogs/covid-warning/covid-warning.component";
import { InsuranceProvidersListDialogComponent } from "../../shared/dialogs/insurance-providers-list-dialog/insurance-providers-list-dialog.component";
import { getZoneDiffTime } from "../../shared/helpers/moment-geo-time";
import { translateToEnglish } from "../../shared/helpers/string.utils";
import { LoadingService } from "../../shared/services/loading.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-doctor-page",
  templateUrl: "./doctor-page.component.html",
  styleUrls: ["./doctor-page.component.scss"],
})
export class DoctorPageComponent implements OnInit, OnDestroy {
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public apiUrl = CONFIG.API.REST.API_URLS["ApiUrl"];
  public baseUrl = environment.baseUrl;
  public mock: any = [1, 2, 3, 5];
  public serviceTypesId: number = null;
  public serviceTypes: any = [];
  public serviceGroupsId: null = null;
  public serviceGroups: any = [];
  public serviceCategories: any = [];
  public isIos: boolean = false;
  public id: string = null;

  showMore: boolean = false;

  doctorPublicProfile: DoctorPublicProfileModel;
  doctorCriteriaRating: DoctorCriteriaRatingModel;
  doctorComments: DoctorCommentModel[] = [];
  doctorTotalRating: number;
  dataAvailable: boolean;

  @ViewChild("doctorReviews") doctorReviews: ElementRef<any>;
  selectedDoctorData: {
    data: any;
    renderDates: any;
    selectedServiceType: any;
    selectedSpeciality: any;
  } = {
    data: null,
    selectedServiceType: null,
    selectedSpeciality: null,
    renderDates: null,
  };
  selectedServiceType: any;
  public specialtyId: any;
  public keyword: string;
  public searchServiceType: number;
  public cityId: number;
  public date: any;
  public doctor: any;
  public doctorId: any;
  public Specialties: any[] = [];
  private subscription: Subscription;
  private doctorData: any[] = [];
  private allTimeSlots: any[] = [];
  private doctorHttpParams: HttpParams;
  public selectedLanguage = localStorage.getItem("CurLang") || "ka";
  isInsuranceBubble: boolean = false

  constructor(
    public LS: LanguageService,
    private doctorService: DoctorService,
    public API: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private loc: Location,
    private loadingService: LoadingService,
    private meta: Meta,
    private title: Title,
    private translateService: TranslateService
  ) {
    this.cLang = this.LS.getLang();
    // this.initServiceGroups(this.serviceTypesId);
    // this.initServiceCategories(this.serviceGroupsId);
    this.checkIos();
  }

  public back(): void {
    this.loc.back();
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.doctorHttpParams = new HttpParams();
      this.doctorHttpParams = this.doctorHttpParams.append(
        "DoctorId",
        params.get("id")
      );
      if (params.get("clinic")) {
        this.doctorHttpParams = this.doctorHttpParams.append(
          "clinic-id",
          params.get("clinic")
        );
      }
      this.getDoctorInfo(); 
      this.getDoctorTimeSlotsBySpecialty(this.activatedRoute.snapshot.queryParamMap.get('selectedSpeciality'));
    });
    this.initSpecialties();
  }

  public checkIos(): void {
    const check = localStorage.getItem("ios");
    const body = document.getElementsByTagName("body");
    if (check === "1") {
      body[0].style.paddingTop = "0";
      this.isIos = true;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.doctorService.setSelectedDoctorData(null);
  }

  public initSpecialties() {
    this.API.getSpecialties().subscribe(
      (res: any[]) => {
        if (res) {
          this.Specialties = res;
          // this.getDoctorTimeSlotsBySpecialty(this.Specialties[0].key);
          this.getDoctorTimeData();
        }
      },
      (error) => {}
    );
  }

  getDoctorTimeData() {
    this.subscription = this.doctorService.getSelectedDoctorData.subscribe(
      (data: any) => {
        if (data) {
          this.selectedDoctorData = data;
        } else {
          this.generateRenderDates();
        }
      }
    );
  }

  generateRenderDates() {
    const renderDates = [];
    for (let i = 0; i < 31; i++) {
      const today = moment().add(i, "d").hour(0).minute(0).second(0);
      renderDates.push(today.toDate());
    }
    return renderDates;
  }

  /* init service categories */
  public initServiceCategories(id: number): void {
    this.API.getServiceCategory(id).subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.serviceCategories = res["result"];
          }
          // this.dataInitialized = true;
        }
      },
      (error) => {
        // this.Auth.checkAccess(error);
      }
    );
  }

  /* init service groups */
  public initServiceGroups(id: number): void {
    this.API.getServiceGroup(id).subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.serviceGroups = res["result"];
            console.log((this.serviceGroups = res["result"]));
          }
          // this.dataInitialized = true;
        }
      },
      (error) => {
        // this.Auth.checkAccess(error);
      }
    );
  }

  getDoctorInfo() {
    this.loadingService.setApplicationLoading(true);
    /*
    1. ექიმის საჯარო პროფილი
    2. რეიტინგი კრიტერიუმებით
    3. რეიტინგი და კომენტარები
    4. ჯამური რეიტინგი
    */
    forkJoin([
      this.API.getDoctorPublicProfile(this.doctorHttpParams),
      this.API.getDoctorRatingByCriterion(this.doctorHttpParams),
      this.API.getDoctorRatingAndComments(this.doctorHttpParams),
      this.API.getDoctorSumRating(this.doctorHttpParams),
    ]).subscribe(
      (resultSet: any[]) => {
        this.doctorPublicProfile = resultSet[0];
        this.doctorCriteriaRating = resultSet[1];
        this.doctorComments = resultSet[2];
        this.doctorTotalRating = resultSet[3];
        this.dataAvailable = true;
        // this.meta.updateTag({
        //   property: 'og:description',
        //   content: `${this.doctorPublicProfile.doctorFullname} - ${this.doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityName} - ${this.translateService.instant('consult-online')}`
        // });
        // this.meta.updateTag({
        //   property: 'description',
        //   content: `${this.doctorPublicProfile.doctorFullname} - ${this.doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityName} - ${this.translateService.instant('consult-online')}`
        // });
        // this.meta.updateTag({
        //   name: 'description',
        //   content: `${this.doctorPublicProfile.doctorFullname} - ${this.doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityName} - ${this.translateService.instant('consult-online')}`
        // });
        // this.meta.updateTag({
        //   property: 'og:url',
        //   content: `${this.baseUrl}/ka/eqimi/${translateToEnglish(this.doctorPublicProfile.doctorFullname.replace(/ - /g, '-').replace(/ /g, '-'))}/${this.id}`
        // });
        // this.meta.updateTag({
        //   property: 'og:image',
        //   content: `${this.apiUrl}/files/profile_pic/${this.id}?size=s`
        // });
        this.title.setTitle(
          `${this.doctorPublicProfile.doctorFullname} - ${this.doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityName} | Redmed`
        );
        this.doctorService.getSelectedDoctorData.subscribe((data) => {
          if (data) {
            this.selectedServiceType = data.selectedServiceType;
            this.specialtyId = data.selectedSpeciality;
            this.getDoctorTimeSlotsBySpecialty(data.selectedSpeciality);
          } else {
            this.loadingService.setApplicationLoading(false);
          }
        });
      },
      () => {
        this.loadingService.setApplicationLoading(false);
      }
    );
  }

  getDoctorTimeSlotsBySpecialty(specialtyId, slotDate?) {
    this.loadingService.setApplicationLoading(true);
    let params = new HttpParams();
    params = params.append("SpecialtyId", specialtyId);
    params = params.append("DoctorId", this.id);
    params = params.append(
      "SlotDateFrom",
      slotDate ? slotDate : new Date().getTime()
    );
    params = params.append("ServiceTypeId", this.selectedServiceType || this.activatedRoute.snapshot.queryParamMap.get('selectedServiceType'));
    params = params.append("Days", "3");
    params = params.append(
      "is-insurance-bubble",this.activatedRoute.snapshot.queryParamMap.get('insurance')
    );
    if (this.doctorHttpParams.get("clinic-id")) {
      params = params.append(
        "clinic-id",
        this.doctorHttpParams.get("clinic-id")
      );
    }
    this.API.searchDoctorsSlotsForSpec(params).subscribe(
      (response: any[]) => {
        response.forEach((doctor) => {
          let maxLength = 0;
          for (let slot in doctor.timeSlotDTOs) {
            if (maxLength < doctor.timeSlotDTOs[slot].length) {
              maxLength = doctor.timeSlotDTOs[slot].length;
            }
            if (doctor.timeSlotDTOs[slot].length < 5) {
              const slotLength = doctor.timeSlotDTOs[slot].length;
              for (let i = 0; i < 5 - slotLength; i++) {
                doctor.timeSlotDTOs[slot].push({
                  slotDate: null,
                  slotId: null,
                  specialtyId: specialtyId,
                  timeString: "-",
                });
              }
            }
            for (let slot in doctor.timeSlotDTOs) {
              if (doctor.timeSlotDTOs[slot].length < maxLength) {
                const slotLength = doctor.timeSlotDTOs[slot].length;
                for (let i = 0; i < maxLength - slotLength; i++) {
                  doctor.timeSlotDTOs[slot].push({
                    slotDate: null,
                    slotId: null,
                    specialtyId: specialtyId,
                    timeString: "-",
                  });
                }
              }
            }
          }
        });
        // if (
        //   Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Tbilisi"
        // ) {
        //   response.forEach((doctor) => {
        //     for (let slot in doctor.timeSlotDTOs) {
        //       doctor.timeSlotDTOs[Number(slot) - getZoneDiffTime()] =
        //         doctor.timeSlotDTOs[slot];
        //       delete doctor.timeSlotDTOs[slot];
        //     }
        //   });
        // }
        this.doctor = response[0];
        // let doctor = this.searchResult.findIndex(doctor => doctor.userId === event.doctorId);
        // this.searchResult[doctor] = response[0];
        this.loadingService.setApplicationLoading(false);
      },
      () => {
        this.loadingService.setApplicationLoading(false);
      }
    );
  }

  getObjectKeys(doctorCriteriaRating: DoctorCriteriaRatingModel) {
    return Object.keys(doctorCriteriaRating);
  }

  scrollToReviews() {
    this.doctorReviews.nativeElement.scrollIntoView({ behavior: "smooth" });
  }

  onServiceTypeSelect(event: any) {
    this.selectedServiceType = event;
    // if (this.specialtyId) {
    this.getDoctorTimeSlotsBySpecialty(
      this.specialtyId
        ? this.specialtyId
        : this.activatedRoute.snapshot.queryParamMap.get('selectedSpeciality')
    );
    this.specialtyId = this.specialtyId
      ? this.specialtyId
      : this.activatedRoute.snapshot.queryParamMap.get('selectedSpeciality')
    // }
    if (event === 2) {
      this.dialog.open(CovidWarningComponent);
    }
  }

  onSpecialityChange(event: any) {
    this.specialtyId = event.specialtyId;
    this.getDoctorTimeSlotsBySpecialty(event.specialtyId);
  }

  updateUrl($event) {
    $event.target.src = "assets/photos/avatar-3.png";
  }

  shareOnFacebook(e) {
    let url = "www.google.com";
    e.preventDefault();
    const facebookWindow = window.open(
      "https://www.facebook.com/dialog/share?&display=popup&href=" + url,
      "facebook-popup",
      "height=350,width=600"
    );
    if (facebookWindow.focus) {
      facebookWindow.focus();
    }
    return false;
  }

  getDoctorName(): string {
    return translateToEnglish(
      this.doctorPublicProfile.doctorFullname
        .replace(/ - /g, "-")
        .replace(/ /g, "-")
    );
  }

  goToClinicSearchResults() {
    this.router.navigate(["/search"], {
      queryParams: {
        clinic: this.doctorPublicProfile.clinic.id,
      },
    });
  }

  openInsuranceProvidersList(providers) {
    this.dialog.open(InsuranceProvidersListDialogComponent, {
      width: "430px",
      data: {
        providers: providers,
      },
    });
  }
}